<template>
	<div>
		<div
			class="flex items-center px-2 pt-4 pb-2"
			:class="{
				'bg-primary-gradient text-white shadow-lg': resource.id === currentResourceId,
			}"
		>
			<div class="mr-1">
				<vs-avatar class="border-2 border-solid border-white" :src="photoURL" size="42px" />
			</div>
			<div class="contact__container w-full flex items-center justify-between overflow-hidden">
				<div class="contact__info flex flex-col truncate w-5/6">
					<h5 class="font-semibold" :class="{'text-white': resource.id === currentResourceId}">
						{{ resource.name | title }} {{ resource.lastname | title }}
					</h5>
					<span class="truncate text-lg"
						>{{ $t("VisitPointObject.AssignedVisitPoints") }}: {{ resource_local.total_visit_point }}</span
					>
				</div>

				<div class="flex self-start flex-col items-end w-1/6 truncate">
					<vx-tooltip
						class="cursor-pointer"
						style="z-index: 99999"
						color="primary"
						position="bottom"
						:text="$t('MassiveAssignment.ShowAssignedVisitPointToltip')"
					>
						<feather-icon
							@click="getVisitPoint"
							class="mr-2 mt-2 cursor-pointer"
							:icon="show ? 'ListIcon' : 'ListIcon'"
							:svgClasses="[show ? 'text-danger' : 'text-primary', 'stroke-current h-4 w-4 mb-1 mr-1']"
						></feather-icon>
					</vx-tooltip>
				</div>
			</div>
		</div>

		<div v-if="show">
			<transition name="slide-fade"> </transition>
		</div>

		<vs-popup
			:fullscreen="false"
			:title="$t('VisitPointObject.AssignedVisitPoints')"
			:active.sync="show"
			class="vs-popup--content-custom"
		>
			<massive-assignment-resume-visit-point-list
				v-if="visitPointList.length > 0"
				:btnDelete="false"
				:divider="false"
				:visitPointList="visitPointList"
				:validateRepeat="true"
			></massive-assignment-resume-visit-point-list>
		</vs-popup>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import firebase from "firebase/app";
// Import Store Module
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleResource from "@/store/resource/moduleResource.js";

import MassiveAssignmentResumeVisitPointList from "./MassiveAssignmentResumeVisitPointList.vue";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";

export default {
	components: {
		MassiveAssignmentResumeVisitPointList,
	},
	props: {
		resource: {type: Object, required: true},
	},
	data() {
		return {
			database: firebase.database(),
			avatar: "",
			total: 1,
			resource_local: JSON.parse(JSON.stringify(this.resource)),
			show: false,
			visitPointList: [],
		};
	},
	computed: {
		photoURL() {
			return this.avatar;
		},
		currentResourceId() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("id")) {
				return currentResource.id;
			} else {
				return 0;
			}
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getResourcePhoto() {
			const url = this.resource.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		getSelectedResources() {
			this.$store.dispatch("moduleSchedule/selectedResource", this.resource_local);
		},
		getVisitPoint() {
			if (this.resource_local.total_visit_point <= 0) {
				return;
			}
			if (this.visitPointList.length > 0) {
				this.show = true;
				return;
			}

			this.openLoading();
			this.$store
				.dispatch("moduleVisitPoint/getVisitPoints", {
					order_by: "added_on",
					sort: "DESC",
					resource_id: this.resource_local.id,
					assign: true,
				})
				.then((res) => {
					this.visitPointList = res.records;
					this.show = true;
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
	mounted() {
		this.getResourcePhoto();
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
	},
};
</script>
<style lang="scss" scoped>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
	transition: all 0.3s ease;
}

.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(200px);
	opacity: 0;
}
</style>
